import { Box, Button, Chip, Divider, Typography } from "@material-ui/core";
import {
    Championship,
    ChampionshipTypeColor,
    ChampionshipTypeDescription,
    useThemeBreakpoints,
} from "api";
import React from "react";
import { useHistory } from "react-router";
import { BoxCard } from "ui/componentes/BoxCard";
import { green, grey } from "@material-ui/core/colors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListOl } from "@fortawesome/free-solid-svg-icons";
import { IconCarCrash } from "ui/componentes/Icons";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/model";

interface ChampionshipCardProps {
    championship: Championship;
}

const goToIncidentsReport = (history, championshipId) => () => {
    history.push(`/incidents_report/${championshipId}`);
};

const goToStadings = (history, championshipId) => () => {
    history.push(`/championship/standings/${championshipId}`);
};

const ChampionshipCard: React.FC<ChampionshipCardProps> = ({
    championship,
}) => {
    const { auth } = useSelector((state: RootState) => state.firebase);
    const history = useHistory();
    const { isDownXs } = useThemeBreakpoints();
    return (
        <BoxCard
            minHeight="150px"
            display="flex"
            flexDirection="column"
            padding={0.5}
        >
            <Box padding={1}>
                <Chip
                    label={
                        ChampionshipTypeDescription[
                            championship.championshipType || ""
                        ]
                    }
                    size="small"
                    color="primary"
                    style={{
                        backgroundColor:
                            ChampionshipTypeColor[
                                championship.championshipType || ""
                            ],
                    }}
                />
                {championship.isFixedSetup && (
                    <Chip
                        label={"Setup fixo"}
                        size="small"
                        color="primary"
                        style={{
                            marginLeft: 4,
                            backgroundColor: grey["900"],
                        }}
                    />
                )}
                {championship.isMultiClass && (
                    <Chip
                        label={"Multi-class"}
                        size="small"
                        color="primary"
                        style={{
                            marginLeft: 4,
                            backgroundColor: green["400"],
                        }}
                    />
                )}
            </Box>
            <Box
                flexGrow={1}
                display="flex"
                justifyContent="center"
                alignItems="center"
                textAlign="center"
            >
                <Typography
                    component="h2"
                    variant="h6"
                    style={{ color: "#15312B" }}
                >
                    {championship.name}
                </Typography>
            </Box>
            <Divider />
            <Box height="15%" display="flex" justifyContent="space-evenly">
                <Button
                    variant="text"
                    color="primary"
                    onClick={goToStadings(history, championship.id)}
                    endIcon={<FontAwesomeIcon icon={faListOl} />}
                >
                    {!isDownXs && "Classificação"}
                </Button>
                {auth.uid && (
                    <Button
                        variant="text"
                        color="primary"
                        onClick={goToIncidentsReport(history, championship.id)}
                        startIcon={<IconCarCrash />}
                    >
                        {!isDownXs && "Relatório de Incidentes"}
                    </Button>
                )}
            </Box>
        </BoxCard>
    );
};

export { ChampionshipCard };
